/** @jsxImportSource @emotion/react */
import React from 'react';
import PageTemplate from '@page/admin/page-template';
import ExpressionHome from '@component/admin/expression/expression-home';

const ExpressionListPage: React.FC = () => {
  return (
    <PageTemplate title='표현 관리'>
      <ExpressionHome />
    </PageTemplate>
  );
};

export default ExpressionListPage;
